<script setup>
import { ref, inject, watch } from 'vue';
import { useKaleadicalStore } from '@/stores/kaleadical';
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';
import { router } from '@inertiajs/vue3';

const { search } = useKaleadicalStore();
const { all } = storeToRefs(useKaleadicalStore());
const { profile } = storeToRefs(useUserStore());

const userProfile = ref(null);

watch(() => profile.value, () => {
    userProfile.value = profile.value;
});

const params = ref({
    term: '',
    status: null,
    page: 1,
    sort_by: null,
    per_page: 10,
    role: null,
});

const searchKaleadical = () => {
    search({
        ...params.value,
    });
};

const modals = inject('modals');

const clearSearch = () => {
    params.value.term = '';
    searchKaleadical();
};

const tableUpdate = ({ page, sortBy, itemsPerPage }) => {
    Object.assign(params.value, { page, sort_by: sortBy, per_page: itemsPerPage });
    searchKaleadical();
};

const openModal = (modal, mode = 'Create', kaleadical = null) => {
    modals.show(modal, {
        props: kaleadical ? {
            kaleadical: kaleadical,
            mode: mode
        } : {
            mode: mode,
        }
    }).then(() => {
        searchKaleadical();
    });
};

// import { useOptionsStore } from '@/stores/options';
// const optionsStore = useOptionsStore();
// const { roleOptions } = storeToRefs(optionsStore);

</script>

<template>
<MainContentLayout>
    <template #breadcrumb><BreadCrumb /></template>
    <template #title>{{ $t('label.kaleadical_management') }}</template>
    <template #actions>
        <StyledButton @click="openModal('KaleadicalsModal')"><FontAwesomeIcon icon="plus" class="mr-1" />
            {{  $t('label.new_kaleadical') }}
        </StyledButton>
    </template>
    <div class="grid lg:grid-cols-3 md:gap-4 md:mb-4">
        <StyledSearch
            v-model="params.term"
            v-debounce:500ms="searchKaleadical"
            name="search"
            :label="$t('label.search')"
            :debounce-events="['input']"
            @click:clear="clearSearch" />
    </div>
    <DataTable
        v-if="all"
        :data="all"
        :headers="[
            { title: $t('label.name'), key: 'name', sortable: false },
            { title: $t('label.description'), key: 'description', sortable: false },
        ]"
        :actions="[
            { title: 'Show', icon: 'eye', action: (item) => router.visit('kaleadicals/'+ item.hash ) },
            { title: 'Edit', icon: 'user-edit', action: (item) => openModal('KaleadicalsModal', 'Edit', item), isVisible: (item) => item.user_id === userProfile?.id },
        ]"
        @table-update="tableUpdate" />
</MainContentLayout>
</template>
